var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:( _obj = {}, _obj[("footer-" + _vm.type)] = _vm.type, _obj ),attrs:{"data-background-color":_vm.backgroundColor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright left"},[_vm._v("V2.0.")]),_c('div',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.year)+", SISCOP.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }